import { IIconBase } from '..'

const boxIcon = ({ color = '#333752', height = 16, width = 17 }: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 17 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/box'>
        <g id='box'>
          <path
            id='Vector'
            d='M2.61328 4.96094L8.49995 8.3676L14.3466 4.98094'
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M8.5 14.406V8.35938'
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_3'
            d='M7.11993 1.65287L3.55993 3.6262C2.75326 4.07287 2.09326 5.19287 2.09326 6.11287V9.87954C2.09326 10.7995 2.75326 11.9195 3.55993 12.3662L7.11993 14.3462C7.87993 14.7662 9.12659 14.7662 9.88659 14.3462L13.4466 12.3662C14.2533 11.9195 14.9133 10.7995 14.9133 9.87954V6.11287C14.9133 5.19287 14.2533 4.07287 13.4466 3.6262L9.88659 1.6462C9.11993 1.2262 7.87993 1.2262 7.11993 1.65287Z'
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </svg>
  )
}

export default boxIcon
